export default function runWhenIdle(cb: () => void) {
  if ('requestIdleCallback' in window) {
    requestIdleCallback(cb, { timeout: 2000 })
  } else {
    setTimeout(cb, 200) // Fallback
  }
}
